import gql from 'graphql-tag';
import { Injectable } from '@angular/core';

import { BackendService } from '../new-http/backend.service';
import { ICustomerProducts } from '../../interfaces/infoproducts/purchase.interfaces';
import { ResearchCategoryID } from '../../enum/research-category-id.enum';

@Injectable({ providedIn: 'root' })
export class InfoproductsPurchaseService extends BackendService {

    public infoProductsIdList = [
        ResearchCategoryID.ShortTerm,
        ResearchCategoryID.TurboTrader,
    ];

    public isInfoProduct(categoryId: number): boolean {
        return this.infoProductsIdList.includes(categoryId);
    }

    public isToroPlusCategory(categoryId: number): boolean {
        return categoryId === ResearchCategoryID.ShortTerm;
    }

    public isTurboTraderCategory(categoryId: number): boolean {
        return categoryId === ResearchCategoryID.TurboTrader;
    }

    /**
     * Registra uma nova compra de teste (trial)
     *
     * @param trialPurchase
     * @returns
     */
    public trialRecommendation(trialPurchase) {
        return this.api.post('/infoproduct/trial', trialPurchase);
    }

    /**
     * Busca produtos adquiridos ou cedidos ao cliente
     *
     * @returns
     */
    public async getCustomerProducts(): Promise<ICustomerProducts> {

        const { data } = await this.graphqlApi.query({
            fetchPolicy: 'network-only',
            query: gql`
                query {
                    viewer {
                        courses {
                            id
                            name
                            onOffer
                            coverUrl
                            accessLink
                            mostViewed
                            coverMobileUrl
                        }
                        strategies {
                            id
                            name
                            tags
                            link
                            isTrial
                            coverUrl
                            isExpired
                            expiresAt
                            accessLink
                            advantages
                            description
                            coverMobileUrl
                            category {
                                id
                                name
                            }
                        }
                    }
                }
            `,
        });

        return data.viewer;

    }

}
